import styled from '@benzinga/themetron';

export const Thumb = styled.div`
  height: 80px;
  width: 100%;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  position: relative;
  cursor: pointer;
`;

export const ThumbsContainer = styled.div`
  background: #e6e6e6;
  border: 1px solid #d6d6d6;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  overflow: hidden;
  padding: 1rem;
  max-width: 75%;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
